import React from "react";

export default function SQL_UNIQUE() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_UNIQUE</h1>
      <p>This is the SQL_UNIQUE component generated from the SQL JSON.</p>
    </div>
  );
}
